import "intersection-observer";
import $ from "jquery";
import "jquery-match-height";
import "magnific-popup";
import "slick-carousel";
import SweetScroll from "sweet-scroll";
import lazySizes from "lazysizes";

import "./libs/slider.js";

if (typeof window !== "undefined") {
  window.$ = $;
  window.jQuery = $;
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    // lazysizes
    lazySizes.init();
    document.addEventListener("lazybeforeunveil", function (e) {
      var bg = e.target.getAttribute("data-bg");
      if (bg) {
        e.target.style.backgroundImage = "url(" + bg + ")";
      }
    });

    // スムーススクロール
    const scroller = new SweetScroll({ offset: 0 });

    // ページ内リンク href 置換
    $("[data-scroll]").each(function () {
      const href = $(this).attr("href");
      if (href && !href.startsWith("#")) {
        const split = href.split("#");
        if (split[0] === location.pathname) {
          $(this).attr("href", "#" + split[1]);
        } else {
          $(this).removeAttr("data-scroll");
        }
      }
    });

    // よくある質問の開閉
    $(".biz-faq__item__q").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

  },
  false
);
